import { PlusIcon } from "@xola/icons";
import { Spinner } from "@xola/ui-kit";
import React, { useRef, useState } from "react";
import { Attachment } from "types";
import { SecondaryButton } from "./SecondaryButton";

interface FileUploadInputProps {
    onChange: (file: Attachment) => void;
    onError?: (error: string) => void;
    isLoading?: boolean;
    maxSizeMB?: number;
    buttonLabel?: string;
}

export const FileUploadInput = ({
    onChange,
    onError,
    isLoading = false,
    maxSizeMB = 10,
    buttonLabel = "Upload",
    ...props
}: FileUploadInputProps) => {
    const inputReference = useRef<HTMLInputElement>(null);
    const [inputKey, setInputKey] = useState(0);

    const handleUploadClick = () => {
        inputReference?.current?.click();
    };

    const handleChange = (event: any) => {
        const [file] = event.target.files;
        if (maxSizeMB && 1_048_576 * maxSizeMB < file.size) {
            onError?.(`File size shouldn't exceed ${maxSizeMB}MB`);
            return;
        }

        onChange(file);

        setInputKey(inputKey + 1);
    };

    return (
        <div className="flex items-center space-x-2">
            <SecondaryButton type="button" icon={<PlusIcon />} disabled={isLoading} onClick={handleUploadClick}>
                {buttonLabel}
            </SecondaryButton>
            <input
                key={inputKey}
                ref={inputReference}
                className="hidden"
                type="file"
                multiple={false}
                accept="application/pdf"
                onChange={handleChange}
                {...props}
            />
            {isLoading && <Spinner />}
        </div>
    );
};
